import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import * as generic from '../../../components/Generico';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputComponent } from '../../../components/InputComponent';
import { ClientePNService } from '../../../service/ClientePNService';
import { ValorEntregado } from '../../../models/cpn/ValorEntregado';
import { ReferenciaBancaria } from '../ReferenciaBancaria';
import { ReferenciaComercial } from '../ReferenciaComercial';
import { ReferenciaPersonal } from '../common/ReferenciaPersonal';
import { Tercero } from '../Tercero';
import { BottomActionBar } from '../../../components/ui/BottomActionBar';

export const AmpliadaPn = ({ id, toast, tipo, seccion, permss, catalogos, soloLectura, back, next }) => {

    const esTipoEspecial = ['FRM_TOYOTA', 'FRM_DIFARE'].includes(catalogos?.tipoFrmEmpresa);
    const omodel = new ValorEntregado({ tipoFrmEmpresa: catalogos?.tipoFrmEmpresa });
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError } = useForm({ defaultValues });
    const { inText, inDrop } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const clientepnSrv = new ClientePNService();
    const [esBeneficiario, setEsBeneficiario] = useState(true);
    const [siTercero, setSiTercero] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const esToyota = catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA';
    const esDifare = catalogos?.tipoFrmEmpresa === 'FRM_DIFARE';

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const editFicha = () => {
        setIsLoading(true);
        clientepnSrv.consultarClientepn(id, seccion).then(res => {
            const cats = catalogos;
            const _clientepn = res.data.clientepn;
            setEsBeneficiario(_clientepn?.tipo_valor_entregado?.cat_id === cats.ben_final?.cat_id || _clientepn?.tipo_valor_entregado?.cat_id === cats.tercero?.cat_id);
            reset(generic.renewValues(_clientepn, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onChangeTipoValor = (e) => {
        setEsBeneficiario(e.value?.cat_id === catalogos.ben_final?.cat_id || e.value?.cat_id === catalogos.tercero?.cat_id);
    }

    const totalTercero = (total) => {
        setSiTercero(total > 0);
    }

    const onSubmit = (data) => {
        setIsSaving(true);
        data.seccion = seccion;
        data.id = id;
        clientepnSrv.editarClientepn(data).then(res => {
            generic.funcSuccess(res, toast);
            next();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <div className="fadein animation-duration-300">
            <form id="ampliadaPnForm" onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
                <Panel header={generic.renderPanelHeader('C.1', 'ORIGEN DE LOS VALORES', 'pi pi-money-bill')} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid mb-4">
                        {inText('detalle_act_economica', { icon: 'pi pi-briefcase' }, 6)}
                        {inDrop('tipo_valor_entregado', catalogos?.valorEntregado, { lab: omodel.optionLabel, chn: onChangeTipoValor, ne: soloLectura ? true : siTercero }, 6)}

                        <div className="col-12 mt-2 text-sm text-600 font-italic">
                            {omodel.strBeneficiario}
                        </div>
                    </div>

                    {esBeneficiario && (
                        <>
                            <div className="col-12 mb-3 mt-3">
                                <div className="flex align-items-center">
                                    <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                        <i className="pi pi-users text-primary"></i>
                                        BENEFICIARIO FINAL / TERCEROS
                                    </span>
                                    <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                                </div>
                                <div className="text-sm text-600 font-italic mt-2 mb-3">
                                    En caso de señalar Beneficiario Final o Tercero/s complete lo siguiente:
                                </div>
                            </div>
                            <div className="col-12 px-0 mb-4">
                                <Tercero toast={toast} tipo={tipo} id={id} permss={permss} lista={catalogos} soloLectura={soloLectura} totalTercero={totalTercero} tipoFrmEmpresa={catalogos?.tipoFrmEmpresa} />
                            </div>
                        </>
                    )}

                    <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mt-4 mb-2">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-info-circle text-blue-600 text-lg"></i>
                            <span className="font-bold text-blue-900">Declaración</span>
                        </div>
                        {omodel.strBeneDeclara}
                    </div>
                </Panel>

                {!esToyota && (
                    <Panel header={generic.renderPanelHeader('C.2', 'REFERENCIAS', 'pi pi-address-book')} className="panel-ficha shadow-1 mb-4">
                        <div className="col-12 mb-3 mt-2">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-building-columns text-primary"></i>
                                    REFERENCIAS BANCARIAS
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                        </div>
                        <div className="col-12 px-0 mb-4">
                            <ReferenciaBancaria tipo={tipo} id={id} toast={toast} permss={permss} bvg={false} num={8} tipoFrmEmpresa={catalogos?.tipoFrmEmpresa} soloLectura={soloLectura} />
                        </div>
                        <div className="col-12 mt-2 mb-3">
                            <div className="flex align-items-center">
                                <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                    <i className="pi pi-shop text-primary"></i>
                                    REFERENCIAS COMERCIALES O PERSONALES
                                </span>
                                <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                            </div>
                            {!esTipoEspecial && (
                                <div className="text-sm text-600 font-italic mt-2 mb-3">
                                    Únicamente en el caso de ser requerido por el vendedor.
                                </div>
                            )}
                        </div>
                        <div className="col-12 px-0 mb-4">
                            <ReferenciaComercial tipo={tipo} id={id} toast={toast} permss={permss} num={9} soloLectura={soloLectura} />
                        </div>
                        {esDifare && (
                            <>
                                <div className="col-12 mt-2 mb-3">
                                    <div className="flex align-items-center">
                                        <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                            <i className="pi pi-id-card text-primary"></i>
                                            REFERENCIAS PERSONALES
                                        </span>
                                        <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                                    </div>
                                </div>
                                <div className="col-12 px-0 mb-2">
                                    <ReferenciaPersonal tipo={tipo} id={id} toast={toast} permss={permss} num={10} soloLectura={soloLectura} />
                                </div>
                            </>
                        )}
                    </Panel>
                )}

                <BottomActionBar formId="ampliadaPnForm" onPrev={back} onNext={next} loading={isSaving} isReadOnly={soloLectura} />
            </form>
        </div>
    )
}
